import { render, staticRenderFns } from "./PassportSwitch.vue?vue&type=template&id=12792438&scoped=true&"
import script from "./PassportSwitch.vue?vue&type=script&lang=js&"
export * from "./PassportSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PassportSwitch.vue?vue&type=style&index=0&id=12792438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12792438",
  null
  
)

export default component.exports